var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.events),function(event){return _c('div',{key:event.phase.ApplyExtrinsic},[_c('CardEvents',{attrs:{"header":"system.ExtrinsicSuccess","content":event.event.data[0],"open":_vm.open}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }